import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'cdtUserCode',
    detailIdProp: 'cdtId',
    detailUrl: '/DmCdtDetail',
    listUrl: '/CdtList',
    mapProp: 'cdtMap',
    name: '定制数据类型',
    textProp: 'cdtName',
    type: 'CDT',
}
